import { render, staticRenderFns } from "./ImagesSlider.vue?vue&type=template&id=324828ca&"
import script from "./ImagesSlider.vue?vue&type=script&lang=ts&"
export * from "./ImagesSlider.vue?vue&type=script&lang=ts&"
import style0 from "./ImagesSlider.vue?vue&type=style&index=0&id=324828ca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports